'use client';

import React, { PropsWithChildren } from 'react';
import { cn } from '@ecom/helper-react-class-combine';
import { CarouselContext } from '../carousel-context';
import { useCarousel } from '../use-carousel';
import { CarouselLabels } from '../carousel-labels';

interface CarouselProps extends PropsWithChildren {
  slideCount: number;
  loop?: boolean;
  autoplay?: boolean;
  autoplayDelay?: number;
  labels?: CarouselLabels;
  className?: string;
}

export function Carousel({
  slideCount,
  loop,
  autoplay,
  autoplayDelay,
  labels,
  className,
  children,
}: CarouselProps): React.ReactElement {
  const api = useCarousel({ slideCount, loop, autoplay, autoplayDelay, labels });

  return (
    <CarouselContext.Provider value={api}>
      <div
        className={cn('relative', className)}
        role='region'
        aria-roledescription='carousel'
        aria-label={api.labels.regionLabel}
      >
        {children}
      </div>
    </CarouselContext.Provider>
  );
}
